import React from 'react';
import styles from '../index.module.scss';

export const SurgeryHeader = ({ surgeryIndex }: { surgeryIndex: number }) => {
  return <div className={styles.title}>{`Surgery ${surgeryIndex + 1}`}</div>;
};
